module.exports = __webpack_public_path__ + "img/91ne.11ee9882.svg";